import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttempts } from '../components/FailedAttempts';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <>
      <HeroSection data-id="element-315" />
      <OpeningHook data-id="element-316" />
      <ProblemSection data-id="element-317" />
      <FailedAttempts data-id="element-318" />
      <UniqueMechanism data-id="element-319" />
      <WhatYouGet data-id="element-320" />
      <AudienceSection data-id="element-321" />
      <HowItWorks data-id="element-322" />
      <ProofSection data-id="element-323" />
      <FAQSection data-id="element-324" />
      <OfferBlock data-id="element-325" />
      <FooterSection data-id="element-326" />
    </>;
}